import i18n from '../i18n';
import globalConfig from '../config/global/config.json';

export const renderName = (profile) => {
  let name = "";
  if (profile){
    let { title, firstName, lastName } = profile;

    let salKeys = Object.keys(i18n.t(`salutation`, { returnObjects: true }));
    title = salKeys.includes(title) ? i18n.t(`salutation#${title}`) : null;
    
    let nameSequenceConfig = i18n.exists("configuration:SET_NAME_DISPLAY_ORDER") ? i18n.t("configuration:SET_NAME_DISPLAY_ORDER", { returnObjects: true }) : globalConfig["SET_NAME_DISPLAY_ORDER"];
    for (let i = 0; i < nameSequenceConfig.length; i++) {
      switch (nameSequenceConfig[i].toUpperCase()) {
        case "TITLE":
          if (title) {
            name += title.toLowerCase() + ' ';
          }
          break;
        case "FIRSTNAME":
          if (firstName) {
            name += firstName.toLowerCase() + ' ';
          }
          break;
        case "LASTNAME":
          if (lastName) {
            name += lastName.toLowerCase() + ' ';
          }
          break;
        default:
          break;
      }
    }
  }
  name = name.slice(0,-1);
  return i18n.exists("pageHeadingSuffix") ? (name==="" ? name : name + i18n.t("pageHeadingSuffix")) : name;
}